// extracted by mini-css-extract-plugin
export default {"button":"wj-z","reviewSort":"xj-z"};